module.exports = __webpack_public_path__ + "files/b538e70cd01d1752e080f33261b6216a.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-2.png
// module id = 1491
// module chunks = 60